// extracted by mini-css-extract-plugin
export default {"quantityContainer":"quantityContainer__ZjbS2","caption":"caption__BpBYk","title":"title__J7Qsg","subtext":"subtext__1hDjf","quantities":"quantities__2LTg0","quantity":"quantity__1M_FF","notZero":"notZero__1cJ0X","quantityControls":"quantityControls__2HfRU","quantityButton":"quantityButton__12doz","plus":"plus__3raGC"};
    if(module.hot) {
      // 1745482222182
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  